'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = createClient;

var _actionCreators = require('./actionCreators');

var _mapResourceStateToProps = require('./mapResourceStateToProps');

var _mapResourceStateToProps2 = _interopRequireDefault(_mapResourceStateToProps);

var _collectionTransform = require('./collectionTransform');

var _collectionTransform2 = _interopRequireDefault(_collectionTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createClient(baseUrl, clientOptions) {
  if (arguments.length === 1 && (typeof baseUrl === 'undefined' ? 'undefined' : _typeof(baseUrl)) === 'object') {
    // Calling createClient({ ... }) is equivalent to createClient('/', {...})
    clientOptions = baseUrl;
    baseUrl = '/';
  }

  function dispatchCreator() {
    if (arguments.length === 1 && _typeof(arguments.length <= 0 ? undefined : arguments[0]) === 'object') {
      return createResources(arguments.length <= 0 ? undefined : arguments[0]);
    }

    return createResource.apply(undefined, arguments);
  }

  function createResources(hash) {
    return Object.keys(hash).reduce(function (memo, name) {
      var definitionOptions = hash[name];
      memo[name] = createResource(name, definitionOptions === true ? {} : definitionOptions);
      return memo;
    }, {});
  }

  function createResource(name) {
    var definitionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var options = definitionOptions;

    if (!name) {
      throw new Error('name required');
    }

    if (!options || !options.url && !options.urlRoot) {
      options = _extends({}, options, { url: name });
    }

    var actionCreators = (0, _actionCreators.resourceActionCreators)(baseUrl, name, options, clientOptions);
    return Object.assign((0, _mapResourceStateToProps2.default)(name, options), options, actionCreators);
  }

  dispatchCreator.baseUrl = baseUrl;
  dispatchCreator.createCollection = function (nm) {
    var dopts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var transform = dopts.transform ? [_collectionTransform2.default, dopts.transform] : _collectionTransform2.default;
    return createResource(nm, _extends({}, dopts, { transform: transform }));
  };

  return dispatchCreator;
}


//////////////////
// WEBPACK FOOTER
// ../dist/createClient.js
// module id = 874
// module chunks = 0